var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7879 11.5459V6.77405C22.7879 5.63986 22.7879 5.07277 22.5489 4.72426C22.3402 4.41977 22.0169 4.21293 21.653 4.151C21.2364 4.08011 20.7215 4.31776 19.6917 4.79305L7.59561 10.3759C6.67719 10.7998 6.21798 11.0117 5.88165 11.3404C5.58431 11.631 5.35734 11.9857 5.2181 12.3775C5.06059 12.8206 5.06059 13.3264 5.06059 14.3379V21.0913M23.4697 20.4095H23.4833M5.06059 15.9095L5.06059 24.9095C5.06059 26.4369 5.06059 27.2006 5.35785 27.784C5.61932 28.2972 6.03654 28.7144 6.54971 28.9759C7.13311 29.2732 7.89681 29.2732 9.42423 29.2732H25.2424C26.7698 29.2732 27.5335 29.2732 28.1169 28.9759C28.6301 28.7144 29.0473 28.2972 29.3088 27.784C29.606 27.2006 29.606 26.4369 29.606 24.9095V15.9095C29.606 14.3821 29.606 13.6184 29.3088 13.035C29.0473 12.5218 28.6301 12.1046 28.1169 11.8431C27.5335 11.5459 26.7698 11.5459 25.2424 11.5459L9.42423 11.5459C7.89681 11.5459 7.13311 11.5459 6.54971 11.8431C6.03654 12.1046 5.61932 12.5218 5.35785 13.035C5.06059 13.6184 5.06059 14.3821 5.06059 15.9095ZM24.1515 20.4095C24.1515 20.7861 23.8462 21.0913 23.4697 21.0913C23.0931 21.0913 22.7879 20.7861 22.7879 20.4095C22.7879 20.033 23.0931 19.7277 23.4697 19.7277C23.8462 19.7277 24.1515 20.033 24.1515 20.4095Z",
    stroke: "#379E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.eadd75904d17b773ff7f201a02713403.svg";
export { ForwardRef as ReactComponent };